// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  '***': {
    '***': [
      {
        metric: 1,
        label: 'Ad Effect Score',
        inHeader: true,
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        label: 'IN-MARKET POTENTIAL',
        rowType: 'hb0'
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 2,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 3,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 4,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 5,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 6,
        label: 'Follow or otherwise interact with the brand on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 7,
        label: 'Talk about the ad with friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 8,
        label: 'Contact this brand directly (call, email, DM, etc.)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 9,
        label: 'Compare the features/services/pricing offered by this brand against those of competitors',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 10,
        label: 'Sign up for a new account or open more types of accounts from this brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 11,
        label: 'Correct Brand ID',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 12,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 13,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 14,
        label: 'Brand Prominence',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 15,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 16,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 17,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 18,
        label: 'Fulfills my needs',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 19,
        label: 'Makes me feel closer to the brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 20,
        label: 'Portrays a brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 21,
        label: 'Values its customers',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 22,
        label: 'Product Connection',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 23,
        label: 'Financial product/service better than currently available',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 24,
        label: 'Offers high-quality features and benefits',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 25,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 26,
        label: 'Easy to do business with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 27,
        label: 'Product(s)/service(s) that are different than others',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 28,
        label: 'Innovative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 29,
        label: 'Cognition',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 30,
        label: 'Tells me something new',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 31,
        label: 'Credible from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 32,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 33,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 34,
        label: 'Presents info at a good pace',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 35,
        label: 'Clear',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 36,
        label: 'Confusing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 37,
        label: 'Engagement',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 38,
        label: 'Worth talking about',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 39,
        label: 'Attention grabbing',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 40,
        label: 'Memorable',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 41,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 42,
        label: 'Unique',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 43,
        label: 'Entertaining',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 44,
        label: 'Humorous',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 45,
        label: 'Heartwarming',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 46,
        label: 'Annoying',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 47,
        label: 'Relevance',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 48,
        label: 'Gives me peace of mind',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 49,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 50,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 51,
        label: 'Shows people/situations I can relate to',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 52,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 53,
        label: 'Category Connection',
        rowType: 'dh0',
        dataFormat: '.,0',
        reverseStat: false
      },
      {
        metric: 54,
        label: 'Shows product(s)/service(s) that pique my interest',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 55,
        label: 'Helps me achieve my goals',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 56,
        label: 'Addresses an issue that\'s important to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 57,
        label: 'Provides info/tools that make me feel confident',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/components/scorecard/MetricsLabels/metricsLabels.js